import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  urlRoot: "/pricetypes",

  defaults: {
    id: "",
    per_contingent: "",
    complete_days: "",
    name: "",
    description: "",
    description2: "",
    created: "",
    modified: "",
  },
});
